import {apiurl} from '@/services/config'

const API_URL = apiurl+ '/auth/signup'
export const MitraServerService = {
  add
}

async function add (postdata) {
  var data = JSON.stringify({ postdata })
  return fetch(API_URL, {
    method: 'POST',
    body: JSON.stringify(JSON.parse(data).postdata),
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(handleResponse)
    .then(data => {
      return data
    })
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)

    if (!data.success) {
      if (response.status === 401) {
        console.log("CALL LOGOUT");
        localStorage.setItem('token',null);
        localStorage.clear();
        location.reload(true)
      }
      const error = (data && data.msg) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}
